<template>
    <div>
        <v-dialog v-model="crudDialog" fullscreen persistent>
            <v-card>
                <v-toolbar card color="primary" class="white--text" >
                    <v-toolbar-title><h4>{{ formTitle }}</h4></v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <v-container grid-list-md>
                        <v-layout wrap>
                            <v-flex xs12 sm6>
                                <v-text-field
                                        v-model="editedItem.first_name"
                                        label="Nombre"
                                        placeholder="Nombre"
                                        :error-messages="userNameErrors"
                                        :counter="60"
                                        required
                                        @input="$v.editedItem.first_name.$touch()"
                                        @blur="$v.editedItem.first_name.$touch()"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6>
                                <v-text-field
                                        v-model="editedItem.last_name"
                                        label="Apellido"
                                        placeholder="Apellido"
                                        :error-messages="userLastNameErrors"
                                        :counter="60"
                                        required
                                        @input="$v.editedItem.last_name.$touch()"
                                        @blur="$v.editedItem.last_name.$touch()"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6>
                                <v-text-field
                                        v-model="editedItem.username"
                                        label="Nombre de Usuario"
                                        :error-messages="userUsernameErrors"
                                        :counter="30"
                                        required
                                        @input="$v.editedItem.username.$touch()"
                                        @blur="$v.editedItem.username.$touch()"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6>
                                <v-text-field
                                        v-model="editedItem.email"
                                        label="Email"
                                        :error-messages="userEmailErrors"
                                        @input="$v.editedItem.email.$touch()"
                                        @blur="$v.editedItem.email.$touch()"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6>
                                <v-select
                                        :items="roles"
                                        v-model="editedItem.roles"
                                        label="Roles"
                                        multiple
                                ></v-select>
                            </v-flex>
                            <v-flex xs12 sm6 v-if="editedItem.roles.includes('CLIENTE')">
                                <v-autocomplete
                                        v-model="editedItem.cliente"
                                                :items="clients"
                                                :search-input.sync="searchClient"
                                                cache-items
                                                item-text="nombre"
                                                item-value="id"
                                                label="Cliente"
                                                clearable
                                                hide-details
                                                return-object
                                ></v-autocomplete>
                            </v-flex>
                            <v-flex xs12 sm6 v-if="editedItem.roles.includes('ASESOR')">
                                <v-autocomplete
                                        v-model="editedItem.asesor"
                                        :items="asesores"
                                        :search-input.sync="searchAsesor"
                                        cache-items
                                        item-text="nombre"
                                        item-value="id"
                                        label="Asesor"
                                        clearable
                                        hide-details
                                        return-object
                                ></v-autocomplete>
                            </v-flex>
                            <v-flex xs12>
                                <v-switch
                                        label="Habilitado"
                                        v-model="editedItem.enabled"
                                ></v-switch>
                            </v-flex>
                            <v-flex xs12 sm6>
                                <v-text-field
                                        v-model="password"
                                        :append-icon="show1 ? 'visibility_off' : 'visibility'"
                                        :error-messages="userPasswordErrors"
                                        @input="$v.password.$touch()"
                                        @blur="$v.password.$touch()"
                                        :type="show1 ? 'text' : 'password'"
                                        label="Cambiar Clave"
                                        hint="Mínimo 8 caracteres"
                                        counter
                                        @click:append="show1 = !show1"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6>
                                <v-text-field
                                        v-model="passwordConfirm"
                                        :append-icon="show2 ? 'visibility_off' : 'visibility'"
                                        :error-messages="userRepeatPasswordErrors"
                                        @input="$v.passwordConfirm.$touch()"
                                        @blur="$v.passwordConfirm.$touch()"
                                        :type="show2 ? 'text' : 'password'"
                                        label="Confirmar Clave"
                                        hint="Confirmar clave"
                                        counter
                                        @click:append="show2 = !show2"
                                ></v-text-field>
                            </v-flex>
                        </v-layout>
                    </v-container>

                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" :disabled="$v.$invalid" @click.native="save">Guardar</v-btn>
                    <v-btn color="secondary" @click.native="close">Cancelar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-card>
            <v-toolbar card>
                <v-btn
                    fab
                    small
                    color="success"
                    bottom
                    left
                    absolute
                    @click="addItem"
                    >
                    <v-icon>add</v-icon>
                </v-btn>


                <v-toolbar-title><h4>Gestión de Usuarios</h4></v-toolbar-title>
                <v-spacer></v-spacer>
                <v-text-field
                        v-model="searchFilter.name"
                        append-icon="search"
                        label="Buscar"
                        single-line
                        @change="onSearchfilterChanged"
                        hide-details
                ></v-text-field>
            </v-toolbar>
            <v-card-text class="pa-0">
                <template>
                    <v-data-table
                            :headers="headers"
                            :items="items"
                            :total-items="totalItems"
                            :pagination.sync="pagination"
                            :loading="loading"
                            :hide-actions="loading"
                            :rows-per-page-items="itemsPerPage"
                            class="elevation-0"
                    >
                        <template slot="items" slot-scope="props">
                            <td>{{ props.item.last_name }},{{ props.item.first_name }}</td>
                            <td>{{ props.item.roles.join(',') }}</td>
                            <td>
                                <span v-if="props.item.asesor != null">{{ props.item.asesor.nombre }}</span>
                                <span v-if="props.item.cliente != null">{{ props.item.cliente.nombre }}</span>
                            </td>
                            <td><v-icon>{{ props.item.enabled ? 'check' : 'close' }}</v-icon></td>
                            <td>{{ props.item.created.format('DD-MM-YYYY hh:mm') }}</td>
                            <td class="text-xs-right">
                                <v-btn v-if="props.item.id !== '' && props.item.enabled " flat icon color="primary" @click="switchUser(props.item)">
                                    <v-icon>fingerprint</v-icon>
                                </v-btn>
                                <v-btn flat icon color="teal" @click="editItem(props.item)">
                                    <v-icon>edit</v-icon>
                                </v-btn>
                                <v-btn flat icon color="pink" @click="deleteItem(props.item)">
                                    <v-icon>delete</v-icon>
                                </v-btn>
                            </td>
                        </template>
                    </v-data-table>
                </template>
                <v-divider></v-divider>
            </v-card-text>
            <v-snackbar color="error" error v-if="error" :timeout="errorTimeout" :bottom="true"
                        v-model="error">
                {{ errorMessage }}
                <v-btn secondary flat @click.native="error = false">Close</v-btn>
            </v-snackbar>
            <v-snackbar color="success" v-if="success" :timeout="successTimeout" :bottom="true"
                        v-model="success">
                {{ successMessage }}
            </v-snackbar>
        </v-card>
    </div>

</template>

<script>
  import { required, maxLength, email, minLength, sameAs } from 'vuelidate/lib/validators'
  import {phoneValidator} from '@/util/validators'
  import axios from '@/api/axios'
  import moment from 'moment'
  import qs from 'qs'
  import store from '@/store'

  const usernameUnique = (value, parentVm) => {
    if (value === '') return true
    store.dispatch('setDisabledLoading', true)
    return axios.post('/users/exists', qs.stringify({ username: value, id: parentVm.id }))
      .then(res => {
        return !res.data
      }).finally(() => (store.dispatch('setDisabledLoading', false)))
  }

  export default {
    data () {
      return {
        error: false,
        errorMessage: '',
        errorTimeout: 6000,
        success: false,
        successMessage: '',
        successTimeout: 2000,
        searchFilter: {
          name: ''
        },
        items: [],
        totalItems: 0,
        pagination: {
          page: 1,
          search: ''
        },
        crudDialog: false,
        editedIndex: -1,
        editedItem: {
          id: '',
          title: null,
          first_name: '',
          last_name: '',
          email: '',
          enabled: true,
          password: '',
          cliente: null,
          cliente_id: null,
          asesor: null,
          asesor_id: null,
          password_changed: false,
          roles: [],
          created: moment(),
          updated: moment()
        },
        defaultItem: {
          id: '',
          title: null,
          first_name: '',
          last_name: '',
          email: '',
          enabled: true,
          password: '',
          cliente: null,
          cliente_id: null,
          asesor: null,
          asesor_id: null,
          password_changed: false,
          roles: [],
          created: moment(),
          updated: moment()
        },
        show1: false,
        show2: false,
        password: '',
        passwordConfirm: '',
        searchClient: null,
        clients: [],
        searchAsesor: null,
        asesores: [],
        roles: [
          {text: 'ADMINISTRADOR', value: 'ADMINISTRADOR'},
          {text: 'GESTION', value: 'GESTION'},
          {text: 'ASESOR', value: 'ASESOR'},
          {text: 'CLIENTE', value: 'CLIENTE'}
        ],
        loading: false,
        headers: [
          {
            text: 'Apellido y Nombre',
            align: 'left',
            sortable: true,
            value: 'mid'
          },
          {
            text: 'Roles',
            align: 'left',
            sortable: true,
            value: 'name'
          },
          {
            text: 'Cliente/Asesor',
            align: 'left',
            sortable: false,
            value: 'cliente'
          },
          {
            text: 'Habilitado',
            align: 'left',
            sortable: true,
            value: 'enabled'
          },
          {
            text: 'Creado',
            align: 'left',
            sortable: true,
            value: 'created'
          },
          { text: 'Acciones', value: 'action', align: 'right', sortable: false }
        ]
      }
    },
    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'Nuevo Usuario' : 'Editar Usuario'
      },
      itemsPerPage () {
        return store.getters['itemsPerPage']
      },
      userUsernameErrors () {
        let errors = []
        if (!this.$v.editedItem.username.$dirty) return errors
        !this.$v.editedItem.username.maxLength && errors.push('Máximo 30 caracteres')
        !this.$v.editedItem.username.required && errors.push('El nombre de usuario es requerido.')
        !this.$v.editedItem.username.usernameUnique && errors.push('El nombre de usuario ya existe.')
        return errors
      },
      userNameErrors () {
        let errors = []
        if (!this.$v.editedItem.first_name.$dirty) return errors
        !this.$v.editedItem.first_name.maxLength && errors.push('Máximo 60 caracteres')
        !this.$v.editedItem.first_name.required && errors.push('El nombre es requerido.')
        return errors
      },
      userLastNameErrors () {
        let errors = []
        if (!this.$v.editedItem.last_name.$dirty) return errors
        !this.$v.editedItem.last_name.maxLength && errors.push('Máximo 60 caracteres')
        !this.$v.editedItem.last_name.required && errors.push('El apellido es requerido.')
        return errors
      },
      userEmailErrors () {
        let errors = []
        if (!this.$v.editedItem.email.$dirty) return errors
        !this.$v.editedItem.email.required && errors.push('Email requerido.')
        !this.$v.editedItem.email.email && errors.push('Email inválido')
        return errors
      },
      userPasswordErrors () {
        let errors = []
        if (!this.$v.password.$dirty) return errors
        if (this.editedIndex === -1) {
          !this.$v.password.required && errors.push('Clave requerida')
        }
        !this.$v.password.minLength && errors.push('Clave mínima 8 caracteres')
        return errors
      },
      userRepeatPasswordErrors () {
        let errors = []
        if (!this.$v.passwordConfirm.$dirty) return errors
        !this.$v.passwordConfirm.sameAsPassword && errors.push('La clave y su confirmación deben ser iguales')
        return errors
      }
    },
    methods: {
      getDataFromApi () {
        this.loading = true
        const {sortBy, descending, page, rowsPerPage, search} = this.pagination
        this.axios.post('/users',
          qs.stringify(
            {
              page,
              rowsPerPage,
              sortBy,
              descending,
              search
            })).then(
          response => {
            this.items = response.data.data.map(function (item) {
              item.created = moment(item.created)
              item.updated = moment(item.updated)
              return item
            })
            this.totalItems = response.data.total_entries
            this.loading = false
          }
        ).catch(
          err => {
            console.log(err)
            this.loading = false
            this.errorMessage = 'Error al cargar listado'
            this.error = true
          }
        )
      },
      addItem () {
        this.crudDialog = true
        this.editedItem = JSON.parse(JSON.stringify(this.defaultItem))
        this.editedIndex = -1
        this.$v.$reset()
      },
      deleteItem (item) {
        this.$root.$confirm('Borrar Usuario', `¿Está seguro de borrar el usuario ${item.last_name}, ${item.first_name} ?`, { color: 'error' }).then(
          (confirm) => {
            if (confirm === true) {
              this.axios.delete('/users/delete/' + item.id).then(
                response => {
                  this.successMessage = 'Usuario borrado exitosamente.'
                  this.success = true
                  this.getDataFromApi()
                  this.close()
                }
              ).catch(
                _ => {
                  this.errorMessage = 'Error al borrar el usuario'
                  this.error = true
                  this.close()
                }
              )
            }
          },
          (reject) => { console.log(reject) })
      },
      editItem (item) {
        this.editedIndex = this.items.indexOf(item)
        this.editedItem = JSON.parse(JSON.stringify(item))
        this.editedItem.created = moment(this.editedItem.created)
        this.editedItem.updated = moment(this.editedItem.updated)
        if (this.editedItem.cliente) {
          this.editedItem.cliente.nombre_completo = this.editedItem.cliente.apellido + ', ' + this.editedItem.cliente.nombre
        }
        this.crudDialog = true
      },
      close () {
        this.crudDialog = false
        setTimeout(() => {
          this.editedItem = JSON.parse(JSON.stringify(this.defaultItem))
          this.$v.$reset()
        }, 300)
      },
      save () {
        let url = ''
        if (this.editedIndex > -1) {
          if (this.password !== '') {
            this.editedItem.password = this.password
            this.editedItem.password_changed = true
          }
          url = '/users/update'
        } else {
          this.editedItem.password = this.password
          this.editedItem.password_changed = true
          url = '/users/add'
        }
        this.axios.post(url, this.editedItem).then(
          response => {
            this.successMessage = 'Usuario guardado exitosamente.'
            this.success = true
            this.getDataFromApi()
            this.close()
          }
        ).catch(
          _ => {
            this.errorMessage = 'Error al guardar usuario.'
            this.error = true
            this.close()
          }
        )
      },
      switchUser (item) {
        this.$store.dispatch('user/setLoading', true)
        this.axios.post(`/users/impersonate/${item.id}`, this.editedItem).then(
          response => {
            const payload = {
              user: response.data,
              token: response.data.token
            }
            this.$store.dispatch('user/switchUser', payload)
            this.$store.dispatch('user/setLoading', false)
          }
        ).catch(
          _ => {
            this.errorMessage = 'Error al impersonarse'
            this.error = true
            this.$store.dispatch('user/setLoading', false)
          }
        )
      },
      onSearchfilterChanged () {
        this.pagination.search = this.searchFilter.name
        this.pagination.page = 1
      },
      searchClients (val) {
        this.$store.dispatch('setDisabledLoading', true)
        this.axios.get('/clientes/search', { params: { search: val } })
          .then(res => {
            this.clients = res.data
          })
          .catch(err => {
            console.log(err)
          })
          .finally(() => (this.$store.dispatch('setDisabledLoading', false)))
      },
      searchAsesores (val) {
        this.$store.dispatch('setDisabledLoading', true)
        this.axios.get('/asesores/search', { params: { search: val } })
          .then(res => {
            this.asesores = res.data
          })
          .catch(err => {
            console.log(err)
          })
          .finally(() => (this.$store.dispatch('setDisabledLoading', false)))
      }
    },
    validations () {
      if (this.editedIndex === -1) {
        return {
          editedItem: {
            username: {required, maxLength: maxLength(30), usernameUnique},
            first_name: {required, maxLength: maxLength(60)},
            last_name: {required, maxLength: maxLength(60)},
            email: {required, email},
            phone: {phoneValidator}
          },
          password: {
            required,
            minLength: minLength(8),
            maxLength: maxLength(20)
          },
          passwordConfirm: {
            required,
            sameAsPassword: sameAs('password')
          }
        }
      } else {
        return {
          editedItem: {
            username: {required, maxLength: maxLength(30), usernameUnique},
            first_name: {required, maxLength: maxLength(60)},
            last_name: {required, maxLength: maxLength(60)},
            email: {required, email},
            phone: {phoneValidator}
          },
          password: {
            minLength: minLength(8),
            maxLength: maxLength(20)
          },
          passwordConfirm: {
            sameAsPassword: sameAs('password')
          }
        }
      }
    },
    watch: {
      pagination: {
        handler () {
          this.getDataFromApi()
        },
        deep: true
      },
      searchClient (val) {
        val && (!this.editedItem.cliente || val !== this.editedItem.cliente.nombre) && this.searchClients(val)
      },
      searchAsesor (val) {
        val && (!this.editedItem.asesor || val !== this.editedItem.asesor.nombre) && this.searchAsesores(val)
      }
    },
    components: {
    },
    mounted () {
      this.searchClients('')
      this.searchAsesores('')
    },
    name: 'UserList'
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Admin/UserList.vue